import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { Warning } from '@mui/icons-material';

interface AutoLogoutWarningProps {
  isVisible: boolean;
  timeLeft: number;
  onExtendSession: () => void;
  onLogout: () => void;
}

const AutoLogoutWarning: React.FC<AutoLogoutWarningProps> = ({
  isVisible,
  timeLeft,
  onExtendSession,
  onLogout
}) => {
  return (
    <Dialog open={isVisible} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Warning color="warning" />
          Session Timeout Warning
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          You will be automatically logged out due to inactivity in:
        </Typography>
        <Box textAlign="center" my={2}>
          <Typography variant="h3" color="error" component="span">
            {timeLeft}
          </Typography>
          <Typography variant="body1" component="span" sx={{ ml: 1 }}>
            seconds
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          Logout Now
        </Button>
        <Button onClick={onExtendSession} variant="contained" color="primary">
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoLogoutWarning;
